import { CarbonProjectItem } from './CarbonProjectItem';
import { CollectionItem } from './CollectionItem';
import { CollectionSubscriptionItem } from './CollectionSubscriptionItem';
import { DriveItemType } from './DriveItem.types';
import { FolderItem } from './FolderItem';
import { ProductItem } from './ProductItem';
import { SpectrumItem } from './SpectrumItem';
import { UrlItem } from './UrlItem';

export type DriveItem =
  | FolderItem
  | CollectionItem
  | CollectionSubscriptionItem
  | CarbonProjectItem
  | ProductItem
  | SpectrumItem
  | UrlItem;

export function createDriveItem(raw: Any): DriveItem {
  const type = raw.type as DriveItemType;

  switch (type) {
    case DriveItemType.Folder:
      return new FolderItem(raw);

    case DriveItemType.Collection:
      return new CollectionItem(raw);

    case DriveItemType.CollectionSubscription:
      return new CollectionSubscriptionItem(raw);

    case DriveItemType.CarbonProject:
      return new CarbonProjectItem(raw);

    case DriveItemType.Product:
      return new ProductItem(raw);

    case DriveItemType.Spectrum:
      return new SpectrumItem(raw);

    case DriveItemType.Url:
      return new UrlItem(raw);

    default:
      throw new Error(`Unknown drive item type: ${String(raw.type)}`);
  }
}

export * from './BaseCollectionItem';
export * from './CarbonProjectItem';
export * from './CollectionItem';
export * from './CollectionSubscriptionItem';
export * from './DriveItem.types';
export * from './FolderItem';
export * from './ProductItem';
export * from './SpectrumItem';
export * from './UrlItem';
